export const cardsImageWrapper = {
  background: "#E7F79B",
  borderRadius: "50%",
  width: "29rem",
  height: "29rem",
};

export const card1Alignment = {
  top: -115,
  left: 100,
};
